import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner',
  template: `
    <div class="loader">
      <i class="fal fa-spinner-third fa-spin loader__icon"></i>
    </div>
    `,
})

export class SpinnerComponent {
}
